import clsx from 'clsx';

import { tg } from '../../lib/tg';

export interface ChipOption<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  label?: string;
  options: ReadonlyArray<ChipOption<T>>;
  value: T;
  onChange: (v: T) => void;
}

/**
 * Single horizontal row: optional eyebrow label on the left, chip
 * group on the right. Wraps when chips don't fit. Used by both the
 * Trades and Wallet filter sections so they look consistent.
 */
export function ChipRow<T extends string>({
  label,
  options,
  value,
  onChange,
}: Props<T>) {
  return (
    <div className="flex items-center justify-between gap-3">
      {label ? (
        <span className="pb-eyebrow shrink-0">{label}</span>
      ) : null}
      <div className="flex flex-wrap items-center justify-end gap-1.5">
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                tg.hapticLight();
                onChange(opt.value);
              }}
              className={clsx(
                'pb-focus-ring rounded-pb-sm border px-2.5 py-1 text-[12px] font-medium transition-colors',
                active
                  ? 'border-pb-accent bg-pb-accent text-white'
                  : 'border-pb-border-soft bg-pb-paper text-tg-hint hover:text-tg-text',
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
